<template>
  <!--<div style="height: calc(100% + 10px); margin:0 -10px; width: 100%; display: inline-block;">-->
  <div style="height: 100vh; width: 100vw; display: inline-block; position: fixed; left: 0; top: 0;">
    <!--<div id="header">-->
    <!--<HomeHeader></HomeHeader>-->
    <!--</div>-->
    <HomeTitle :area-name="areaName"></HomeTitle>
    <div id="main">
      <div id="left">
        <div id="homeLeftOne" v-show="inHome">
          <HomeLeftOne v-if="inHome"></HomeLeftOne>
        </div>
        <div id="homeLeftTwo" v-show="inHome">
          <HomeLeftTwo v-if="inHome"></HomeLeftTwo>
        </div>
        <div id="homeLeftThree" v-show="inHome">
          <HomeLeftThree v-if="inHome"></HomeLeftThree>
        </div>
        <div id="subLeftOne"  v-show="!inHome">
          <!--再次添加v-if，因为要让echarts进行二次渲染-->
          <SubLeftOne v-if="!inHome" :area-id="areaId"></SubLeftOne>
        </div>
        <div id="subLeftTwo" v-show="!inHome">
          <SubLeftTwo v-if="!inHome" :area-id="areaId"></SubLeftTwo>
        </div>
        <div id="subLeftThree" v-show="!inHome">
          <SubLeftThree v-if="!inHome" :area-id="areaId"></SubLeftThree>
        </div>

      </div>
      <div id="center" style="margin: 0 10px;">
        <HomeHeader @getHomeMapFeedBack="getHomeMapFeedBack" :area-id="areaId" :area-name="areaName"></HomeHeader>
        <HomeMap @feedBack="getHomeMapFeedBack" :area-name="areaName" ></HomeMap>
      </div>
      <div id="right" >
        <div id="homeRightOne"  v-show="inHome">
          <HomeRightOne v-if="inHome"></HomeRightOne>
        </div>
        <div id="homeRightTwo"  v-show="inHome"  style="min-height: 260px;">
          <HomeRightTwo v-if="inHome"></HomeRightTwo>
        </div>
        <div id="homeRightThree" v-show="inHome">
          <HomeRightThree v-if="inHome" :area-id="areaId" :area-name="areaName"></HomeRightThree>
        </div>
        <div id="subRightOne" v-show="!inHome">
          <SubRightOne v-if="!inHome" :area-id="areaId"></SubRightOne>
        </div>
        <div id="subRightTwo" v-show="!inHome" >
          <SubRightTwo v-if="!inHome" :area-id="areaId"></SubRightTwo>
        </div>
        <div id="subRightThree" v-show="!inHome" style="top: 30px;">
          <SubRightThree v-if="!inHome" :area-id="areaId"></SubRightThree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from './homeComponents/HomeHeader'
import HomeLeftOne from './homeComponents/HomeLeftOne'
import HomeLeftTwo from './homeComponents/HomeLeftTwo'
import HomeLeftThree from './homeComponents/HomeLeftThree'
import HomeRightOne from './homeComponents/HomeRightOne'
import HomeRightTwo from './homeComponents/HomeRightTwo'
import HomeRightThree from './homeComponents/HomeRightThree'
import HomeMap from './homeComponents/HomeMap'
import HomeTitle from './homeComponents/HomeTitle'

import jquery from 'jquery'
import SubRightOne from './homeComponents/SubAreaCharts/SubRightOne'
import SubRightTwo from './homeComponents/SubAreaCharts/SubRightTwo'
import SubRightThree from './homeComponents/SubAreaCharts/SubRightThree'
import SubLeftOne from './homeComponents/SubAreaCharts/SubLeftOne'
import SubLeftTwo from './homeComponents/SubAreaCharts/SubLeftTwo'
import SubLeftThree from './homeComponents/SubAreaCharts/SubLeftThree'
var fun= function () {
  console.log('hello');
}
export default {
  name: 'BigScreen',
  components: { SubLeftThree, SubLeftTwo, SubLeftOne, SubRightThree, SubRightTwo, SubRightOne, HomeTitle, HomeMap, HomeRightThree, HomeRightTwo, HomeRightOne, HomeLeftThree, HomeLeftTwo, HomeLeftOne, HomeHeader },
  data(){
    const self = this;
    return {
      inHome: true, // 是否在市区界面
      areaName: '南京市',
      fullscreen: true,
      areaId: "0",
    }
  },
  methods: {

    fadeHome(){
      new Promise(resolve =>{
        // console.log('点击了');
        let arrRight = ['homeRightOne', 'homeRightTwo', 'homeRightThree'];
        let arrLeft = ['homeLeftOne', 'homeLeftTwo', 'homeLeftThree'];
        let index = 0;
        let interval = setInterval(()=>{
          var objLeft = document.getElementById(arrLeft[index]);
          var objRight = document.getElementById(arrRight[index]);
          this.fadeElement(objLeft, -1);
          this.fadeElement(objRight, 1);
          if(index++ >= Math.min(arrRight.length, arrLeft)- 1){
            clearInterval(interval);
            resolve();
          }
        },200);
      }).then(()=>{
        this.showSub();
      })
    },
    showHome(){
      let arrRight = ['homeRightOne', 'homeRightTwo', 'homeRightThree'].reverse();
      let arrLeft = ['homeLeftOne', 'homeLeftTwo', 'homeLeftThree'].reverse();
      let all = arrLeft.concat(arrRight);
      all.forEach(item=>{
        var obj = document.getElementById(item);
        obj.style.opacity = 0;
      })
      this.inHome = true;
      let index = 0;
      let interval = setInterval(()=>{
        var objLeft = document.getElementById(arrLeft[index]);
        var objRight = document.getElementById(arrRight[index]);
        this.showElement(objLeft, -1);
        this.showElement(objRight, 1);
        if(index++ >= Math.min(arrRight.length, arrLeft.length) - 1){
          clearInterval(interval);
        }
      },200);
    },
    showSub(){
      this.inHome = false;
      let arrRight = ['subRightOne', 'subRightTwo', 'subRightThree'].reverse();
      let arrLeft = ['subLeftOne', 'subLeftTwo', 'subLeftThree'].reverse();
      let all = arrRight.concat(arrLeft);
      all.forEach(item=>{
        var obj = document.getElementById(item);
        obj.style.opacity = 0;
      })
      this.inHome = false;
      let index = 0;
      let interval = setInterval(()=>{
        var objLeft = document.getElementById(arrLeft[index]);
        var objRight = document.getElementById(arrRight[index]);
        console.log('objLeft:' + arrLeft[index]);
        console.log('objRight:' + arrRight[index]);
        this.showElement(objLeft, -1);
        this.showElement(objRight, 1);
        if(index++ >= Math.min(arrLeft.length, arrRight.length) - 1){
          clearInterval(interval);
        }
      },100);
    },
    fadeSub(){
      new Promise(resolve => {
        let arrRight = ['subRightOne', 'subRightTwo', 'subRightThree'].reverse();
        let arrLeft = ['subLeftOne', 'subLeftTwo', 'subLeftThree'].reverse();
        this.inHome = false;
        let index = 0;
        let interval = setInterval(()=>{
          var objLeft = document.getElementById(arrLeft[index]);
          var objRight = document.getElementById(arrRight[index]);
          this.fadeElement(objLeft, 1);
          this.fadeElement(objRight, -1);
          if(index++ >= Math.min(arrLeft.length, arrRight.length) - 1){
            clearInterval(interval);
            resolve();
          }
        },100);
      }).then(()=>{
        this.showHome();
      })

    },
    getHomeMapFeedBack(areaName, areaId){
      this.areaId = areaId;
      this.areaName = areaName;
    },
    // 全屏事件
    handleFullScreen(){
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    // 消失
    fadeElement(obj, direction){
      // direction：-1:向左，1:向右
      let interval = null;
      let opacity = 1;
      let left = 0;
      let p = new Promise(resolve => {
        interval = setInterval(()=>{
          obj.style.opacity = opacity;
          opacity = opacity - 0.05;
          // console.log(obj.style.opacity);
          left = left + direction * 2.5;
          obj.style.left = left + "px";
          // console.log(obj.style.left);
          if(obj.style.opacity <= 0){
            resolve(clearInterval(interval));
          }
        }, 5);
      }).then(()=>{
        // console.log('隐藏了');
      })
    },
    // 展示元素
    showElement(obj, direction){
      // direction：-1:向左，1:向右
      obj.style.opacity = 0;
      let interval = null;
      let opacity = 0;
      let left = -50;
      if(direction === -1){
        left = 50;
      }
      new Promise(resolve => {
        interval = setInterval(()=>{
          obj.style.opacity = opacity;
          opacity = opacity + 0.05;
          // console.log(obj.style.opacity);
          left = left + direction * 2.5;
          obj.style.left = left + "px";
          // console.log(obj.style.left);
          if(obj.style.opacity >= 1){
            resolve(clearInterval(interval));
          }
        }, 5);
      }).then(()=>{
        console.log('隐藏了');
      })
    },
  },
  // watch:{
  //   areaName(newValue, oldValue){
  //     if(newValue === '泰州市'){
  //       this.fadeSub();
  //     }else{
  //       this.showSub();
  //     }
  //   },
  //   timeRange(newValue, oldValue){
  //     this.GetMapInformation.params.startTime = newValue[0];
  //     this.GetMapInformation.params.endTime = newValue[1];
  //   },
  //
  // },
  mounted() {
    this.token = this.$store.state.token;
  },

}
</script>
<style scoped>
  .search_in_map span{
    color: white; font-size: 16px
  }
  .search_in_map .el-button{
    margin-top: 20px;
    width: 100%;
  }
  #header{
    width: 100%;
    height: 50px;
    /*background-color: yellow;*/
  }
  #main{
    display: flex;
    display: -moz-flex;
    display: -webkit-flex;
    height: 100%;
    background: radial-gradient(circle, #0f266a, #0e112d);
    background: -ms-radial-gradient(circle, #0f266a, #0e112d);
    background: -webkit-linear-gradient(circle, #0f266a, #0e112d);
    background: -moz-linear-gradient(circle, #0f266a, #0e112d);
    overflow: hidden;
    justify-content: space-around;
  }
  #left{
    width: 400px;
  }
  #right{
    width: 500px;
  }
  #left, #right{
    position: relative;
    width: 400px;
    height: 90%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  #left > div, #right > div{
    position: relative;
    flex: 1;
    min-height: 230px;
    opacity: 1;
  }
  #rightFirst, #rightSecond{
    /*height: 200px;*/
  }
  #center{
    flex: 1;
    position: relative;
    /*background-color: blue;*/
  }
</style>
<style>
  /*.makerLabel{*/
  /*display: inline-block;*/
  /*line-height: 30px;*/
  /*width: 100px;*/
  /*color: #99a9bf;*/
  /*}*/
</style>
